// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".info[data-v-51edb985] {\n  padding-top: 20px;\n}\n.item[data-v-51edb985] {\n  width: 100%;\n  padding: 10px 20px;\n  margin-bottom: 10px;\n  box-sizing: border-box;\n  background-color: #f2f2f2;\n}\n.item .item-name[data-v-51edb985] {\n  font-size: 14px;\n}\n[data-v-51edb985] .page-pageination {\n  text-align: right;\n  padding-top: 10px;\n}\n[data-v-51edb985] .page-pageination .el-input {\n  display: inline-block !important;\n}\n", ""]);
// Exports
module.exports = exports;
